import { NgModule } from '@angular/core';
import { CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from '@angular/common';
import { ControlPanelComponent } from './control-panel.component';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { CalendarModule } from 'primeng/calendar';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgxPaginationModule } from 'ngx-pagination';
import { DropdownModule } from 'primeng/dropdown';

// PIPE'S
import { FilterPipe } from '../control-panel/_pipes/filter.pipe';
import { WellFilterPipe } from '../control-panel/_pipes/wellFilter.pipe';
import { WellCreateFilterPipe } from '../control-panel/_pipes/wellCreateFilter.pipe';
import { SanitizePipe } from '../control-panel/_pipes/sanitize.pipe';
import { FieldsACLFilterPipe } from '../control-panel/_pipes/fieldsACLFilter.pipe';
import { WellsACLFilterPipe } from '../control-panel/_pipes/wellACLFilter.pipe';
import { ReportsACLFilterPipe } from '../control-panel/_pipes/reportACLFilter.pipe';
import { TruncatePipe } from '../control-panel/_pipes/truncate.pipe';
import { GroupsFilterPipe } from '../control-panel/_pipes/groupsFilter.pipe';


// COMPONENT'S

import { UserSettingsComponent } from '../control-panel/usersettings/usersettings.component';
import { SingleUserComponent } from '../control-panel/singleuser/singleuser.component'
import { WellsComponent } from '../control-panel/wells/wells.component';
import { AddWellComponent } from '../control-panel/addwell/addwell.component';
import { FieldsACLComponent } from '../control-panel/acl/fields/fieldsACL.component';
import { WellsACLComponent } from '../control-panel/acl/wells/wellsACL.component';
import { ReportsACLComponent } from '../control-panel/acl/reports/reportsACL.component';
import { FieldsExpendituresACLComponent } from '../control-panel/acl/fieldsexpenditures/fieldsexpendituresACL.component';

//MODALS
import { ManualPasswordResetModalComponent } from '../control-panel/modals/manualPasswordReset/manualPasswordResetModal.component';

// SERVICE'S
import { UsersService } from '../control-panel/_services/users.service';

import { WellsService } from '../control-panel/_services/wells.service';
import { CanDeactivateGuard } from '../control-panel/guards/can-deactivate.guard';
import { ComponentRefService } from '../control-panel/_services/componentRef.service';
import { SharedFunctionsService } from '../control-panel/_services/sharedFunctions.service';



//DIRECTIVE'S
import { MyAutofocusDirective } from '../control-panel/_directive/myAutoFocus.directive';

const appRoutes: Routes = [
  {
    path: '',
    component: ControlPanelComponent,
    children: [
      {
        path: 'users',
        component: UserSettingsComponent,
        
      },
      {
        path: 'wells',
        component: WellsComponent,
       
      },     
      {
        path: 'users/user/:username',
        canDeactivate: [CanDeactivateGuard],
        component: SingleUserComponent,
        
      },
      {
        path: 'wells/add',
        canDeactivate: [CanDeactivateGuard],
        component: AddWellComponent,
       
      },
    ]
  }
];

@NgModule({
  declarations: [
    ManualPasswordResetModalComponent,
    MyAutofocusDirective,
    ControlPanelComponent,
    UserSettingsComponent,
    SingleUserComponent,
    WellsComponent,
    AddWellComponent,
    FieldsACLComponent,
    WellsACLComponent,
    ReportsACLComponent,
    FieldsExpendituresACLComponent,
    FilterPipe,
    WellFilterPipe,
    WellCreateFilterPipe,
    SanitizePipe,
    FieldsACLFilterPipe,
    WellsACLFilterPipe,
  ReportsACLFilterPipe,
    TruncatePipe,
    GroupsFilterPipe
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(appRoutes),
    SharedModule,
    CalendarModule,
    NgxPermissionsModule,
    DropdownModule,
    NgxPaginationModule
  ],
  providers: [
    UsersService,
    WellsService, 
    ComponentRefService,   
    CanDeactivateGuard,  
    SharedFunctionsService,   
  ],
  exports: [
    RouterModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ControlPanelModule { }
